import React from "react";
import { FiChevronRight } from "react-icons/fi";
import {
  SectionContent,
  WidgetCardsContainer,
  WidgetCard,
  Headline,
  Link,
  Card,
  Text,
} from "../../../../components";
import { applyKey } from "../../../../utils";
import * as S from "./TiposDeSeguroSorteiosCards.Style";

const TiposDeSeguroSorteiosCards = () => {
  return (
    <>
      <SectionContent>
        <WidgetCardsContainer>
          {applyKey(
            [
              {
                label: "Seguro Habitacional Tradicional",
                href:
                  "/paravoce/habitacional/resultados-dos-sorteios/seguro-habitacional-tradicional",
              },
              {
                label: "Seguro Habitacional Mais",
                href:
                  "/paravoce/habitacional/resultados-dos-sorteios/seguro-habitacional-mais",
              },
              {
                label: "Seguro Habitacional Mais Premiável",
                href:
                  "/paravoce/habitacional/resultados-dos-sorteios/seguro-habitacional-mais-premiavel",
              },
              {
                label: "Seguro Habitacional Lar + Premiável",
                href:
                  "/paravoce/habitacional/resultados-dos-sorteios/seguro-habitacional-lar-mais-premiavel",
              },
            ],
            ({ label, href }) => (
              <S.TipoSeguroCard
                as={WidgetCard}
                header={
                  <Headline as="3" styleAs="8">
                    {label}
                  </Headline>
                }
              >
                <S.NavigationLinkItemStyled as={Link} href={href}>
                  <S.NavigationCardItemStyled as={Card}>
                    <S.BodyLabelLink
                      as={Text}
                      textType="button"
                      reset={{ marginBottom: "0px" }}
                    >
                      Conferir agora
                    </S.BodyLabelLink>
                    <FiChevronRight />
                  </S.NavigationCardItemStyled>
                </S.NavigationLinkItemStyled>
              </S.TipoSeguroCard>
            )
          )}
        </WidgetCardsContainer>
      </SectionContent>
    </>
  );
};

TiposDeSeguroSorteiosCards.propTypes = {};

export default TiposDeSeguroSorteiosCards;
